'use client';

import SkillzLogo from '@/../public/skillz-logo-white.svg';
import {_m, GradientLabel} from '@sdk-mobile';
import {IDepositOffer} from '@/services/promotions/interfaces';
import {useEffect, useState} from 'react';

const calculateRatio = () => {
  const windowWidth = window.innerWidth;

  const widthZones = [
    {maxWidth: 320, ratio: 0.6}, // Small smartphones
    {maxWidth: 375, ratio: 0.7}, // Medium smartphones
    {maxWidth: 414, ratio: 0.8}, // Large smartphones
    {maxWidth: 480, ratio: 0.82}, // Extra large smartphones
    {maxWidth: 768, ratio: 0.84}, // Tablets
    {maxWidth: Infinity, ratio: 0.9}, // Very wide screens
  ];

  const zone = widthZones.find((zone) => windowWidth <= zone.maxWidth);

  return zone ? zone.ratio : 0.9;
};

// Function to generate styles dynamically based on sizeRatio
const getTextStyles = (baseFontSize = 65, sizeRatio: number, gradientColors: string[]) => ({
  textAlign: 'center',
  fontFamily: 'OpenSans-ExtraBold',
  fontSize: baseFontSize * sizeRatio,
  lineHeight: baseFontSize * sizeRatio + 8,
  fontWeight: 800,
  letterSpacing: '-0.03em',
  textShadowColor: '#000000',
  textShadowRadius: 4,
  textShadowOffset: {
    x: 0,
    y: 1,
  },
  paddingHorizontal: 4,
  gradientColors,
});

const HeroBannerTextV1 = ({sizeRatio}: {sizeRatio: number}) => {
  const marginTop = 45 * sizeRatio;
  const baseFontSize = 44;
  const goldTextStyles = getTextStyles(baseFontSize, sizeRatio, ['#F69D11', '#FCBB0C', '#F69D11']);
  const whiteTextStyles = getTextStyles(baseFontSize, sizeRatio, ['#fff', '#fff']);
  const greenTextStyles = getTextStyles(baseFontSize, sizeRatio, ['#13B657', '#13B657']);

  return (
    <div className={'flex flex-col'} style={{marginTop}}>
      <div className={'flex justify-center'}>
        <GradientLabel style={goldTextStyles}>{_m('Millions')}</GradientLabel>
        <GradientLabel style={whiteTextStyles}>{_m('in prizes')}</GradientLabel>
      </div>
      <div className={'flex justify-center'}>
        <GradientLabel style={whiteTextStyles}>{_m('Simple,')}</GradientLabel>
        <GradientLabel style={greenTextStyles}>{_m('secure payouts')}</GradientLabel>
      </div>
    </div>
  );
};

const HeroBannerTextV2 = ({
  sizeRatio,
  amount,
  bonus,
}: {
  sizeRatio: number;
  amount: number;
  bonus: number;
}) => {
  const baseFontSize = 65;
  const whiteTextStyles = getTextStyles(baseFontSize, sizeRatio, ['#fff', '#fff']);
  const greenTextStyles = getTextStyles(baseFontSize, sizeRatio, ['#13B657', '#13B657']);

  const marginTop = 40 * sizeRatio;
  return (
    <div className={'flex flex-col'} style={{marginTop}}>
      <div className={'flex justify-center'}>
        <GradientLabel style={whiteTextStyles}>{_m('DEPOSIT')}</GradientLabel>
        <GradientLabel style={greenTextStyles}>
          {_m('$')}
          {amount}
        </GradientLabel>
      </div>
      <div className={'flex justify-center'}>
        <GradientLabel style={whiteTextStyles}>{_m('GET')}</GradientLabel>
        <GradientLabel style={greenTextStyles}>
          {_m('$')}
          {bonus}
        </GradientLabel>
        <GradientLabel style={whiteTextStyles}>{_m('ON US')}</GradientLabel>
      </div>
      <div className={'flex justify-center'}>
        {/* <GradientLabel style={goldTextStyles}>{_m('WHEN')}</GradientLabel> */}
      </div>

      <p
        className={
          'text-white text-center font-open-sans font-light text-[10px] leading-[14px] tracking-[-0.03em] mt-1 mb-2'
        }
      >
        {_m('Offer valid only for new users registering their account')}
      </p>
    </div>
  );
};

interface Props {
  limitedTimeOffers: IDepositOffer[];
}

const HeroBanner = ({limitedTimeOffers}: Props) => {
  const [sizeRatio, setSizeRatio] = useState(calculateRatio);

  useEffect(() => {
    const handleResize = () => {
      setSizeRatio(calculateRatio());
    };
    const mediaQuery = window.matchMedia('(orientation: portrait)');

    window.addEventListener('resize', handleResize);
    mediaQuery.addEventListener('change', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
      mediaQuery.addEventListener('change', handleResize);
    };
  }, []);
  const ltoOffer = limitedTimeOffers[0];
  return (
    <div className={'w-screen grow relative min-h-[220px]'}>
      <div className={'flex justify-center mt-8'}>
        <img src={SkillzLogo.src} alt={'Skillz'} className={''} />
      </div>
      <div className={'flex justify-center'}>
        {ltoOffer ? (
          <HeroBannerTextV2 sizeRatio={sizeRatio} amount={ltoOffer.amount} bonus={ltoOffer.bonus} />
        ) : (
          <HeroBannerTextV1 sizeRatio={sizeRatio} />
        )}
      </div>
    </div>
  );
};

export default HeroBanner;
